import { requestGetRes, requestPostRes } from "../EdcService";

export enum ActivityTypeEnum {
  // EDC报名
  EDC = 1,
  // 代表报名
  DELEGATE = 2,
}
export const getSimpleActivities = (type: ActivityTypeEnum)=> requestGetRes(`/plat/apply/activity/${type}`)